import React from 'react';

const IconComment = ({ color, width, height }) => {
  return (
    <svg
      style={{ transform: 'scale(-1, 1)' }}
      fill={color}
      height={height}
      width={width}
      viewBox="0 0 24 24"
    >
      <path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

export default IconComment;



// WEBPACK FOOTER //
// ./src/IconComment.js